<template>
    <footer class="footer has-cards">
        <div class="container">
            <div class="row row-grid align-items-center my-md">
                <div class="col-lg-6">
                    <h3 class="font-weight-light mb-2 text"></h3>
                    <h4 class="mb-0 font-weight-light text">Let's get in touch on any of these platforms.</h4>
                </div>
                <div class="col-lg-6 text-lg-right btn-wrapper">
                    <a target="_blank" href="mailto:m.froehlich@tum.de"
                       class="btn btn-neutral btn-icon-only btn-github btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Email me">
                        <i class="fa fa-paper-plane"></i>
                    </a>
                    <a target="_blank" href="https://frhlch.at"
                       class="btn btn-neutral btn-icon-only btn-github btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Visit frhlch.at">
                        <i class="fa fa-home"></i>
                    </a>
                    <a target="_blank" href="https://github.com/froemic"
                       class="btn btn-neutral btn-icon-only btn-github  btn-lg btn-round" data-toggle="tooltip"
                       data-original-title="Star on Github">
                        <i class="fa fa-github"></i>
                    </a>
                    <a target="_blank" href="https://www.linkedin.com/in/MFrhlch"
                       class="btn btn-neutral btn-icon-only btn-github btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Connect on LinkedIn">
                        <i class="fa fa-linkedin"></i>
                    </a>
                </div>
            </div>
            <hr>
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    <div class="copyright text">
                        &copy; 2018
                        <a href="https://frhlch.at/" target="_blank">Michael Fröhlich</a>.
                    </div>
                </div>
                <div class="col-md-6">
                    <ul class="nav nav-footer justify-content-end">
                        <li class="nav-item">
                            <router-link to="/acknowledgements" class="nav-link">Acknowledgements</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/imprint" class="nav-link">Imprint</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/dataprivacy" class="nav-link">Data Privacy</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {};
</script>
<style scoped lang="scss">
$backgroundColor: #f8c53b;
$textColor: black;
$accentColor: black;

.footer.has-cards {
  padding-top: 680px;
  margin-top: -600px;
}

.footer.has-cards::before {
  background: $backgroundColor;
}

.footer .btn-github,
.footer .btn-github:hover {
  border: white;
  background: white;
  color: black;
}

.footer .text {
  color: $textColor;
}

.footer hr {
  border-color: $textColor;
  opacity: 0.6;
}

.footer a {
  color: $accentColor;
}

.footer a:hover {
  color: $accentColor;
  opacity: 0.7;
}

.footer .nav .nav-item .nav-link,
.footer .footer-link {
  color: $accentColor !important;
  opacity: 0.8;
}

.footer .nav .nav-item .nav-link:hover,
.footer .footer-link:hover {
  color: $accentColor !important;
  opacity: 0.5;
}
</style>
